import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import {
  Market,
  PaymentRequestDto,
} from '@app/model/payment-request/payment-request.dto';
import { HeaderService } from '@app/service/header/header.service';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import {
  CheckoutState,
  StateControlParameters,
  StateService,
} from '@app/service/state/state.service';

@Injectable({
  providedIn: 'root',
})
export class IframeLandingStateResolver implements Resolve<CheckoutState> {
  constructor(
    private stateService: StateService,
    private headerService: HeaderService,
    private queryParamsService: QueryParamsService
  ) {}

  async resolve(): Promise<CheckoutState> {
    try {
      const token = this.queryParamsService.getQueryParams().id;
      this.stateService.setToken(token);

      const paymentRequest: PaymentRequestDto =
        await this.stateService.fetchPaymentRequest(token);

      if (paymentRequest.market === Market.SE) {
        // Return a empty CheckoutState object as appropriate (FE driven don't use CheckoutStates)
        return {} as CheckoutState;
      }

      // Treat Iframe landing page as if it was the HOME page only if is a specific payment method.
      // Else this check is done by the BE driven HOME page resolver called 'RegisterStateResolver'.
      if (
        paymentRequest.specificPaymentMethod &&
        paymentRequest.specificPaymentMethodType
      ) {
        const controlParams: StateControlParameters = {
          currentPageName: 'HOME',
          token: this.stateService.getToken(),
        };

        const state = await this.stateService
          .registerState(controlParams)
          .catch((error) => {
            // If we fail to get the state, then go to error page
            this.stateService.setLandingError(true);
            return null;
          });

        // Set variables
        this.stateService.setCurrentLocale(state?.language);
        this.headerService.setMarket(state?.market);
        this.headerService.setCancelUrl(state?.merchantUrls?.onCancelUrl);
        this.headerService.processReceivedPartnerLogoUri(
          state?.checkoutCustomizations?.logoUrl
        );

        return state;
      }
    } catch (error) {
      this.stateService.setLandingError(true);
    }
  }
}
